module.exports = __webpack_public_path__ + "static/media/kaushal.6c6bdb13.png";